module.exports = __webpack_public_path__ + "img/sia.d0eedfbe.jpg";